'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import cookies from 'js-cookie';
import config from '../../js/config';
import mediator from '../../js/mediator';
import logger from 'loglevel';
import {ContentServiceApi,ProcessError} from './Sitecore';

let log = logger.getLogger('Sitecore');

export default class SitecoreView extends Backbone.View {
  initialize(options) {
    this.datasourceId = this.$el.data('datasourceId');
    this.currentItemId = this.$el.data('currentItemId');
    this.renderingId = this.$el.data('renderingId');
    this.originalRenderingId = this.$el.data('originalRenderingId');
    this.renderingUniqueId = this.$el.data('renderingUniqueId');
    this.renderingParameters = this.$el.data('renderingParameters');
    let $deferred;

    // figure out whether this thing uses either datasource or a current item & retrieve it with Content API
    if (this.datasourceId) {
      $deferred = new ContentServiceApi().getSingleItem(this.datasourceId);
    }
    else if (this.currentItemId) {
      $deferred = new ContentServiceApi().getSingleItem(this.currentItemId);
    }

    // no datasource or current item, create empty deferred
    if (!$deferred) {
      $deferred = $.Deferred();
      $deferred.resolve(undefined);
    }

    // save the resultant item as the model
    $deferred = $deferred.then((data) => {
      this.model = data;
    });

    // if this class uses link fields, after the content service returns, resolve them
    // n.b.: we should do this with image fields.
    if ((typeof options.links !== 'undefined') || (typeof options.images !== 'undefined')) {
      $deferred = $deferred.then(() => {
        let language = cookies.get(config.cookies.arrowLanguage);
        let image = {
          l: language,
          i: this.model.itemID,
          ip: []
        }
        let images = [image];
        let link = {
          l: language,
          i: this.model.itemID,
          f: []
        };
        let links = [link];
        let linkNames = [];
        if (typeof options.links !== 'undefined') {
          // eslint-disable-next-line no-unused-vars
          for (let linkName of options.links) {
            this.model[linkName] = null;
            linkNames.push(linkName);
            link.f.push(linkName);
          }
        }
        if (typeof options.images !== 'undefined') {
          // eslint-disable-next-line no-unused-vars
          for (let imageProperties of options.images) {
            this.model[imageProperties.f] = null;
            image.ip.push(imageProperties)
          }
        }
        let $imageLinkDeferred = $.ajax(config.urls.contentService.imageLink, {
          method: 'POST',
          data: JSON.stringify ({
            images, links
          }),
          contentType: 'application/json'
        }).then((results) => {
          if (typeof results.links !== 'undefined') {
            // eslint-disable-next-line no-unused-vars
            for (let hashable in results.links) {
              let hashableFields = hashable.split(/~/);
              if (hashableFields.length !== 4) {
                throw 'Invalid link hashable in link results';
              }
              let linkName = hashableFields.pop();
              this.model[linkName] = results.links[hashable];
            }
          }
          if (typeof results.images !== 'undefined') {
            // eslint-disable-next-line no-unused-vars
            for (let itemImagePropertyKey in results.images) {
              let itemImages = results.images[itemImagePropertyKey];
              // eslint-disable-next-line no-unused-vars
              for (let imagePropertyKey in itemImages) {
                let index = imagePropertyKey.indexOf('~');
                if (index === -1) {
                  throw 'Invalid image property key in image results';
                }
                let propertyKeyFields = [
                  imagePropertyKey.substr(0, index),
                  imagePropertyKey.substr(index + 1)
                ];
                let imageFieldName = propertyKeyFields[0];
                let sizeWidthKey = propertyKeyFields[1];
                if (!this.model[imageFieldName]) {
                  this.model[imageFieldName] = {};
                }
                this.model[imageFieldName][sizeWidthKey] =
                  itemImages[imagePropertyKey];
              }
            }
          }
        });
        return $imageLinkDeferred;
      });
    }

    // after all that, render
    $deferred.then(() => {
      this.render();
    }).fail((response) => {
      log.error('Got an error initializing SitecoreView for ' + this.constructor.name);
      log.error(response);
      // TODO - we need to be better able to handle errors.
      mediator.trigger(config.events.error.generic, {
        error: {
          title: 'Content Service Error',
          messages: [{
            message: ProcessError(response)
          }]
        }
      });
    });
  }

  get authority() {
    return {
      datasourceId: this.datasourceId,
      currentItemId: this.currentItemId,
      renderingId: this.renderingId,
      originalRenderingId: this.originalRenderingId,
      renderingUniqueId: this.renderingUniqueId,
      renderingParameters: this.renderingParameters
    };
  }
}



// WEBPACK FOOTER //
// ./assets/components/Sitecore/SitecoreView.js